// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-2997b438]{margin-bottom:20px}.container[data-v-2997b438]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
